query FileCabinetFolderDocuments(
  $id: UUID!
  $filter: EntityDocumentFilter
  $orderBy: [EntityDocumentsOrderBy!]
  $first: Int
  $after: Cursor
) {
  fileCabinetPool(id: $id) {
    id
    entityDocumentsByDocumentPoolIdAndEntityTypeId(
      orderBy: $orderBy
      filter: $filter
      first: $first
      after: $after
    ) {
      nodes {
        id
        _documentType
        _documentFileId
        indexName
        indexReferenceNumber
        indexTransactionDate
        _documentContents
        indexAmount
        documentAppliedAmounts {
          usedTotal
          remainingTotal
        }
        currency {
          isoCode
        }
        comment
        fileReference
        _uploadDate
        _exportDate
        indexTransactionDate
        _isProtected
        _fileType
        _fileViewer
        iconType
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
        hasPreviousPage
      }
    }
  }
}
